import { isoZ, z } from 'my-zod'
import { currencyEnum } from '../../internal'
import { transferMetadataTypeEnum } from './transfer-metadata'

export const transactionView = z.object({
  id: z.number(),
  transactionGroup: z.string(),
  account: z.string(),
  amount: z.number().int(),
  currency: currencyEnum,
  createdDate: isoZ.instant(),
  description: z.string(),
  reverses: z.number().nullable(),
  metadataType: transferMetadataTypeEnum,
  otherAccount: z.string()
})

export type transactionView = z.infer<typeof transactionView>
